import { observer } from "mobx-react-lite";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogContent } from "@/components/ui/alert-dialog";
import { modalRegistry } from "@/config/modalRegistry";
import { useStore } from "@/hooks/useStore";

export const Modal = observer(() => {
	const {
		uiStore: { modalStore },
	} = useStore();

	const { type, props } = modalStore;

	if (!type) return null;

	const AlertComponent = modalRegistry.alert[type as keyof typeof modalRegistry.alert];
	if (AlertComponent) {
		return (
			<AlertDialog open>
				<AlertDialogContent>
					<AlertComponent {...(props as any)} />
				</AlertDialogContent>
			</AlertDialog>
		);
	}

	const DialogComponent = modalRegistry.dialog[type as keyof typeof modalRegistry.dialog];
	if (DialogComponent) {
		// Optional statics on the component let a specific modal customise the dialog:
		//   dialogClassName — opt into a wider/taller container (e.g. ManageMembersModal)
		//   disableOutsideClose — block click-outside dismissal (e.g. AlarmWizard)
		//   closeButtonOutside — render the close button outside the dialog edge (e.g. NoteFilePreview)
		const { dialogClassName, disableOutsideClose, closeButtonOutside } = DialogComponent as {
			dialogClassName?: string;
			disableOutsideClose?: boolean;
			closeButtonOutside?: boolean;
		};
		return (
			<Dialog
				open
				onOpenChange={open => {
					if (!open) modalStore.close();
				}}
			>
				<DialogContent
					className={dialogClassName}
					closeButtonOutside={closeButtonOutside}
					onCloseAutoFocus={() => {
						document.body.style.pointerEvents = "";
					}}
					onInteractOutside={disableOutsideClose ? event => event.preventDefault() : undefined}
				>
					<DialogComponent {...(props as any)} />
				</DialogContent>
			</Dialog>
		);
	}

	return null; // unknown modal type
});
